<template>
  <div class="overflow-hidden bg-white shadow sm:rounded-lg">
    <section>
      <div class="px-4 py-5 sm:px-6 border-t border-gray-200 ">
        <h3 class="text-lg font-medium leading-6 text-gray-900">
          Bewertung nach Potenzial
        </h3>
        <p class="mt-1 max-w-2xl text-sm text-gray-500">
          Potentielle Effekte der Methode auf Wachstumsziele
        </p>
      </div>
      <div v-if="resource" class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <dl class="sm:divide-y sm:divide-gray-200">
          <div v-if="resource.coverage" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <CoverageTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.coverage.key" />
              <span class="ml-4">
                ({{ resource.coverage.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.throughput" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ThroughputTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.throughput.key" />
              <span class="ml-4">
                ({{ resource.throughput.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.reputation" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ReputationTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.reputation.key" />
              <span class="ml-4">
                ({{ resource.reputation.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.interaction" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <InteractionTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.interaction.key" />
              <span class="ml-4">
                ({{ resource.interaction.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.monetization" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <MonetizationTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.monetization.key" />
              <span class="ml-4">
                ({{ resource.monetization.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.expertise" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ExpertiseTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.expertise.key" />
              <span class="ml-4">
                ({{ resource.expertise.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.referability" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <ReferabilityTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.referability.key" />
              <span class="ml-4">
                ({{ resource.referability.trans }})
              </span>
            </dd>
          </div>
          <div v-if="resource.enjoyment" class="py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:py-5 sm:px-6">
            <dt class="text-sm font-medium text-gray-500">
              <EnjoymentTooltip />
            </dt>
            <dd class="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0 flex flex-row">
              <Potential :value="resource.enjoyment.key" />
              <span class="ml-4">
                ({{ resource.enjoyment.trans }})
              </span>
            </dd>
          </div>
        </dl>
      </div>
      <div v-if="failure" class="border-t border-gray-200 px-4 py-5 sm:p-0">
        <div class="px-4 py-5 sm:px-6">
          <p class="mt-1 max-w-2xl text-sm text-gray-500">
            Für diese Methode wurden noch keine Potenziale definiert.
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({practice: Object});

const parent = computed(() => props.practice.id);
const target = computed(() => '/api/practices/' + parent.value + '/rating');

const { retrieve, retrieving, resource, failure } = useRetrieveResource(target);

const onMount = onMounted(() => retrieve());
</script>

<style scoped>
.info-icon
{
  @apply h-5 w-5 inline-block;
  @apply text-gray-400;
}
</style>
